import * as eventActions from '../actions/eventActions';
import { get } from 'lodash-es';
const initialState = {};
export default (state = initialState, action) => {
  //NOSONAR
  if (action.type === eventActions.PIGGYBANK_EVENT) {
    const formValues = get(action, 'event.values', '');
    if (
      get(action, 'event.type') === 'onNavigate' &&
      get(action, 'event.component') === 'Wizard' &&
      formValues
    ) {
      return formValues;
    }
    return state;
  }
  return state;
};
